import { APIClient } from '@/_helpers/APIClient'

export default {
  // getUseCoupon (payload) {
  //   let path = './api/get-use-coupon.json/'
  //   return APIClient().get(path)
  // },
  getUseCoupon (payload) {
    let path
    if (payload.type) {
      if (payload.type === '0') {
        path = './api/get-coupon-details-coupon.json?type=' + payload.type
      } else if (payload.type === '1') {
        path = './api/get-coupon-details-prize.json?type=' + payload.type
      }
    } else {
      path = './api/get-coupon-details-coupon.json'
    }
    // path = './api/get-coupon-details-coupon.json/' //+ payload.id
    return APIClient().get(path)
  },
  checkUseCoupon () {
    let path = './api/check-use-coupon.json'
    return APIClient().get(path)
  },
  checkExchangePrize () {
    let path = './api/check-exchange-prize.json'
    return APIClient().get(path)
  }
}
